(function() {
  var PlantingOptions, yearUtil,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  PlantingOptions = App.loadClass('grower::viewmodels/placement/seed_options/PlantingOptions');

  yearUtil = require('resources/assets/coffee/Core/utils/year');

  exports.PlantingPlanFactory = (function() {
    function PlantingPlanFactory() {
      this.create = bind(this.create, this);
    }

    PlantingPlanFactory.prototype.create = function(field, parent_handler, spp_handler, replace_products) {
      var events, layer_id, max_pop, min_pop, options, product, ref, ref1, ref2, ref3, ref4, refuge, refugeApplication, refugeAspect;
      options = {
        company_id: spp_handler.companyID,
        crop_id: spp_handler.cropID,
        spp_id: spp_handler.sppID,
        fsr_id: field.fsr_id,
        survey_result_id: (ref = parent_handler.loadLayoutPostOptions) != null ? ref.result_id : void 0,
        sppPlantingPlan: spp_handler.customPlantingPlan,
        sppPlanterSubscription: spp_handler.customPlanterSubscription,
        sppProductSubscription: spp_handler.customProductSubscription,
        calculate_population: spp_handler.calculates_populations,
        sppPopulationAdjustment: spp_handler.customPopulationAdjustment
      };
      min_pop = (ref1 = spp_handler.getFieldAspectByName(field.id, 'Planting Min Pop')) != null ? ref1.value : void 0;
      max_pop = (ref2 = spp_handler.getFieldAspectByName(field.id, 'Planting Max Pop')) != null ? ref2.value : void 0;
      if ((min_pop != null) && (max_pop != null)) {
        options.min_max_pop = {
          min: min_pop,
          max: max_pop
        };
      }
      if (replace_products) {
        product = field.hybrid_selection();
        refuge = field.refuge_selection();
        if ((product != null) && (refuge != null)) {
          refugeAspect = spp_handler.getFieldAspectByName(field.id, 'Refuge Configuration');
          refugeApplication = (ref3 = refugeAspect != null ? (ref4 = refugeAspect.option_name) != null ? ref4.toLowerCase().split(' ')[0] : void 0 : void 0) != null ? ref3 : 'strips';
          switch (refugeApplication) {
            case 'block':
              events = [
                {
                  stages: [
                    {
                      seed_company: product.seed_companies_id,
                      product: product.id
                    }
                  ]
                }, {
                  stages: [
                    {
                      seed_company: refuge.seed_companies_id,
                      product: refuge.id
                    }
                  ]
                }
              ];
              break;
            case 'adjacent field':
              events = [
                {
                  stages: [
                    {
                      seed_company: product.seed_companies_id,
                      product: product.id
                    }
                  ]
                }
              ];
              break;
            default:
              events = [
                {
                  stages: [
                    {
                      seed_company: product.seed_companies_id,
                      product: product.id
                    }, {
                      seed_company: refuge.seed_companies_id,
                      product: refuge.id
                    }
                  ]
                }
              ];
          }
        } else {
          events = [
            {
              stages: [
                {
                  seed_company: product != null ? product.seed_companies_id : void 0,
                  product: product != null ? product.id : void 0
                }
              ]
            }
          ];
        }
        options.events = events;
      }
      layer_id = field.planting_plan_id();
      if (layer_id != null) {
        $(window).trigger('spp.edit-planting-plan', {
          year: spp_handler.year,
          field_id: field.id,
          layer_id: layer_id,
          options: options
        });
      } else {
        $(window).trigger('spp.add-planting-plan', {
          year: spp_handler.year,
          field_id: field.id,
          options: options
        });
      }
    };

    return PlantingPlanFactory;

  })();

}).call(this);
